import React from "react";

const New_and_Delete = () => {
  return (
    <div>
      <h1>New_and_Delete Component</h1>
      <p>Content for New_and_Delete goes here...</p>
    </div>
  );
};

export default New_and_Delete;
